<template>
  <div style="text-align: left; margin-left: 20px;">
        <el-table
            :data="$store.state.inventoryMaster.props.estore_downloable"
            style="width: 100%" border>
            <el-table-column
            prop="source_name"
            label="Title" width="250">
            <template slot-scope="scope">
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="scope.row.source_name"
                    style="width: 100%;">
                </el-input>
            </template>
            </el-table-column>
            <el-table-column
            prop="source_link"
            label="Download Link" width="350">
            <template slot-scope="scope">
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="scope.row.source_link"
                    style="width: 100%;">
                </el-input>
            </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a @click="$store.commit('addInventoryMasterDownloadable')" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeInventoryMasterDownloadable', scope.row.key)"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {
    methods: {
        
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/EStore/Downloadables.vue